import React from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import Pavesi from './containers/Pavesi';
import PavesiHomepage from './containers/PavesiHomepage';
import AttentamenteParent from './containers/AttentamenteParent';
import AttentamenteParentAverage from './containers/AttentamenteParentAverage';
import AttentamenteChild from './containers/AttentamenteChild';
import SharedThemeProvider from './shared/SharedThemeProvider';
import Unipolis from './containers/Unipolis';
import CDP from './containers/CDP';
import CdpProposalGrid from './containers/CdpProposalGrid';
import CdpAnagrafica from './containers/CdpAnagrafica';
import E4Impact from './containers/E4Impact';
import E4ImpactMBA from './containers/E4ImpactMBA';
import E4ImpactProjects from './containers/E4ImpactProjects';
import {E4ImpactProjectsProvider} from './containers/E4ImpactProjects/context';
import Feba from './containers/Feba';
import FebaOrganization from './containers/FebaOrganization';
import WIAParent from './containers/WIAParent';
import WIAChild from './containers/WIAChild';
import WIAParentBeneficiary from './containers/WIAParentBeneficiary';
import LibriProject from './containers/LibriProject';
import LibriIniziative from './containers/LibriIniziative';
import AttentamenteSecondParent from './containers/AttentamenteSecondParent';
import AttentamenteSecondParentAverage from './containers/AttentamenteSecondParentAverage';
import AttentamenteSecondChild from './containers/AttentamenteSecondChild';
import NeetworkParent from './containers/NeetworkParent';
import FdcMilanoBeneficiaries from '@/containers/FdcMilanoBeneficiaries';
import FdcMilanoVolunteers from '@/containers/FdcMilanoVolunteers';
import FdcMilanoMaintenanceInterventions from '@/containers/FdcMilanoMaintenanceInterventions';
import FdcMilanoGroupActivities from '@/containers/FdcMilanoGroupActivities';
import FdcMilanoLogbook from '@/containers/FdcMilanoLogbook';
import FdcMilanoCollaborationAgreements from '@/containers/FdcMilanoCollaborationAgreements';
import FsvLuoghi from '@/containers/Fsv/FsvLuoghi';
import FsvIniziative from '@/containers/Fsv/FsvIniziative';
import FsvLuoghi2025 from '@/containers/Fsv/Luoghi2025';
import FsvIniziative2025 from '@/containers/Fsv/Luoghi2025/Iniziativa';
import FsvFdc from '@/containers/Fsv/FsvFdc';
import ZeroNeetActivities from '@/containers/Fsv/ZeroNeet/Activities';
import ZeroNeetBeneficiaries from '@/containers/Fsv/ZeroNeet/Beneficiaries';
import ZeroNeetCollaboration from '@/containers/Fsv/ZeroNeet/Collaboration';
import Attentamente2024Activities from '@/containers/Attentamente2024/Activities';
import Attentamente2024Beneficiaries from '@/containers/Attentamente2024/Beneficiaries';
import {COLORS} from './utils/constants';

import './App.css';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

function App() {
    const router = createBrowserRouter([
        {
            path: '/pavesi',
            element: (
                <SharedThemeProvider mainColor={COLORS.pavesiMain}>
                    <Pavesi />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/pavesi-homepage',
            element: (
                <SharedThemeProvider mainColor={COLORS.pavesiMain}>
                    <PavesiHomepage />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-parent',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <AttentamenteParent />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-parent-average',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <AttentamenteParentAverage />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-child',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <AttentamenteChild />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/unipolis',
            element: (
                <SharedThemeProvider mainColor={COLORS.unipolisMain}>
                    <Unipolis />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/cdp-evaluation-grid',
            element: (
                <SharedThemeProvider mainColor={COLORS.cdpMain}>
                    <CDP />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/cdp-proposal-grid',
            element: (
                <SharedThemeProvider mainColor={COLORS.cdpMain}>
                    <CdpProposalGrid />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/cdp-anagrafica',
            element: (
                <SharedThemeProvider mainColor={COLORS.cdpMain}>
                    <CdpAnagrafica />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/e4-impact',
            element: (
                <SharedThemeProvider mainColor={COLORS.e4ImpactMain}>
                    <E4Impact />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/e4-impact-mba',
            element: (
                <SharedThemeProvider mainColor={COLORS.e4ImpactMain}>
                    <E4ImpactMBA />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/e4-impact-project',
            element: (
                <SharedThemeProvider mainColor={COLORS.e4ImpactMain}>
                    <E4ImpactProjectsProvider>
                        <E4ImpactProjects />
                    </E4ImpactProjectsProvider>
                </SharedThemeProvider>
            ),
        },
        {
            path: '/feba',
            element: (
                <SharedThemeProvider mainColor={COLORS.feba}>
                    <Feba />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/feba-organizations',
            element: (
                <SharedThemeProvider mainColor={COLORS.feba}>
                    <FebaOrganization />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/wia-parent',
            element: (
                <SharedThemeProvider mainColor={COLORS.wiaMain}>
                    <WIAParent />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/wia-child',
            element: (
                <SharedThemeProvider mainColor={COLORS.wiaMain}>
                    <WIAChild />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/wia-parent-beneficiary',
            element: (
                <SharedThemeProvider mainColor={COLORS.wiaMain}>
                    <WIAParentBeneficiary />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/libri-project',
            element: (
                <SharedThemeProvider mainColor={COLORS.libriMain}>
                    <LibriProject />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/libri-iniziative',
            element: (
                <SharedThemeProvider mainColor={COLORS.libriMain}>
                    <LibriIniziative />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-second-parent',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <AttentamenteSecondParent />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-second-parent-average',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <AttentamenteSecondParentAverage />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-second-child',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <AttentamenteSecondChild />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/neetwork-parent',
            element: (
                <SharedThemeProvider mainColor={COLORS.networkMain}>
                    <NeetworkParent />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fdc-milano-beneficiaries',
            element: (
                <SharedThemeProvider mainColor={COLORS.fdcMilano}>
                    <FdcMilanoBeneficiaries />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fdc-milano-volunteers',
            element: (
                <SharedThemeProvider mainColor={COLORS.fdcMilano}>
                    <FdcMilanoVolunteers />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fdc-milano-maintenance-interventions',
            element: (
                <SharedThemeProvider mainColor={COLORS.fdcMilano}>
                    <FdcMilanoMaintenanceInterventions />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fdc-milano-group-activities',
            element: (
                <SharedThemeProvider mainColor={COLORS.fdcMilano}>
                    <FdcMilanoGroupActivities />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fdc-milano-logbook',
            element: (
                <SharedThemeProvider mainColor={COLORS.fdcMilano}>
                    <FdcMilanoLogbook />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fdc-milano-collaboration-agreements',
            element: (
                <SharedThemeProvider mainColor={COLORS.fdcMilano}>
                    <FdcMilanoCollaborationAgreements />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fsv-luoghi',
            element: (
                <SharedThemeProvider mainColor={COLORS.fsv}>
                    <FsvLuoghi edition='2023' />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fsv-luoghi-2024',
            element: (
                <SharedThemeProvider mainColor={COLORS.fsv2024}>
                    <FsvLuoghi edition='2024' />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fsv-iniziative',
            element: (
                <SharedThemeProvider mainColor={COLORS.fsv}>
                    <FsvIniziative />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fsv-iniziative-2024',
            element: (
                <SharedThemeProvider mainColor={COLORS.fsv2024}>
                    <FsvIniziative />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fsv-luoghi-2025',
            element: (
                <SharedThemeProvider mainColor={COLORS.fsv2025}>
                    <FsvLuoghi2025 />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fsv-iniziative-2025',
            element: (
                <SharedThemeProvider mainColor={COLORS.fsv2025}>
                    <FsvIniziative2025 />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/fsv-fdc',
            element: (
                <SharedThemeProvider mainColor={COLORS.fdc}>
                    <FsvFdc />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-2024-activities',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <Attentamente2024Activities />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/attentamente-2024-beneficiaries',
            element: (
                <SharedThemeProvider mainColor={COLORS.attentamenteMain}>
                    <Attentamente2024Beneficiaries />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/zero-neet-activities',
            element: (
                <SharedThemeProvider mainColor={COLORS.zeroNeet}>
                    <ZeroNeetActivities />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/zero-neet-beneficiaries',
            element: (
                <SharedThemeProvider mainColor={COLORS.zeroNeet}>
                    <ZeroNeetBeneficiaries />
                </SharedThemeProvider>
            ),
        },
        {
            path: '/zero-neet-collaboration',
            element: (
                <SharedThemeProvider mainColor={COLORS.zeroNeet}>
                    <ZeroNeetCollaboration />
                </SharedThemeProvider>
            ),
        },
    ]);

    return (
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
        </QueryClientProvider>
    );
}

export default App;
